import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { map, Observable, of } from "rxjs";
import { FiscalYearService } from "../../shared/services/fiscal-year.service";
import { FiscalYearResponse } from "../../shared/models/fiscal-year-model";

@Injectable({
    providedIn: 'root',
})
export class GetFiscalYearsResolver implements Resolve<FiscalYearResponse[]> {

    constructor(
        private fiscalYearService: FiscalYearService,
    ) { }

    resolve(): Observable<FiscalYearResponse[]> {
        return this.fiscalYearService.getAll()
        .pipe(
            map(fiscalYear =>
                fiscalYear.filter(x => !x.isDeleted)
                    .map(year => ({
                        ...year,
                        startDate: new Date(year.startDate),
                        endDate: new Date(year.endDate),
                    }))
            )
        );
    }
}
